// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"795":"a59d90a7","1131":"c8ce17d7","3278":"c8ce17d7","7392":"ab5cb27c","8908":"c8ce17d7"}[chunkId] + ".chunk.css";
};